import { useCallback, useEffect, useState } from "react";
import { useChatbotName } from "../../../components/Chatbot/hooks/use-chatbot-name/use-chatbot-name";
import { clientConstantsServiceInstance } from "../../../services/client-constants/client-constants.service.instance";
import type { ReplaceSinglePlaceholderProps } from "../../../services/client-constants/client-constants.service.interface";
import { GENERAL_SUBSCRIPTION_TO_BONUSX_SUBSCRIPTION_TIER_MAP } from "../../../services/user-subscription/enums/bonusx-subscription-tiers.enum";
import { useCurrentUserSubscriptionTier } from "../../use-current-user-subscription-tier/use-current-user-subscription-tier";
import { useFormValues } from "../../useFormValues";
import { ClientConstantsReplacementsManager } from "./replacements-manager/replacements-manager";

const replacementsManager = new ClientConstantsReplacementsManager();

export function useClientConstantsReplacements() {
  const { Nome } = useFormValues();
  const chatbotName = useChatbotName();
  const { translationKeyForTier, currentUserTier } = useCurrentUserSubscriptionTier();

  const currentUserTierAsBonusxSubscriptionTier = GENERAL_SUBSCRIPTION_TO_BONUSX_SUBSCRIPTION_TIER_MAP[currentUserTier];

  const [replacements, setReplacements] = useState<ReplaceSinglePlaceholderProps[]>([]);

  const revalidateReplacements = useCallback(() => {
    const newReplacements = replacementsManager.getReplacements({
      chatbotName,
      userFirstName: Nome ?? "",
      currentUserTier: currentUserTierAsBonusxSubscriptionTier,
      translationKeyForTier,
    });
    setReplacements(newReplacements);
  }, [chatbotName, Nome, currentUserTierAsBonusxSubscriptionTier, translationKeyForTier]);

  useEffect(
    function updateReplacementsInService() {
      clientConstantsServiceInstance.placeholdersReplacements = replacements;
    },
    [replacements]
  );

  useEffect(
    function updateReplacements() {
      revalidateReplacements();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Nome, chatbotName, currentUserTier, translationKeyForTier]
  );

  return {
    replacements,
    revalidateReplacements,
  };
}
